<template>      
    <div id="ubn" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('departure.UBN') }}</h5>
        <p class="text-sm">{{ $t('common.Mandatory_informations') }} *</p>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-8">
            <div class="input-group input-group-static null">
                <label>{{ $t('departure.UBN') }} *</label>
                <select id="ubnId" v-model="state.ubnId" class="form-control form-control-default">
                    <option value="">{{ $t('departure.Select_UBN') }}</option>
                    <option v-for="item in state.ubns" :key="item.id" :value="item.id">
                        {{ item.ubn }} - {{ item.locationFullAddressDropDown }}
                    </option>
                </select>
                <span v-if="vrulesUBN$.ubnId.$error" class="text-sm text-danger">
                    {{ vrulesUBN$.ubnId.$errors[0].$message }}
                </span>
            </div>
          </div>
        </div>        
        <div class="col-12 col-sm-12 mt-3">
          <button v-on:click="updateUBN" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('departure.Update_UBN') }}</button>
        </div>
      </div>
    </div>    
    <div id="animal" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header pb-3">
        <h5>{{ $t('departure.Animal') }}</h5>
        <p class="mb-0 text-sm">{{ $t('departure.NB_21_days_rule') }}</p>        
      </div>
      <div class="card-body pt-0">   
        <div class="row">
          <div class="col-12">
            <div class="mb-4">
              <p class="fw-bold text-sm">{{ $t('departure.Selected_animals') }} ({{ selectedAnimals.length }})</p>
              <div class="row">
                <div v-for="animal in selectedAnimals" :key="animal.id" class="col-md-6 mb-1">
                  <div class="card border  text-sm border-success bg-light" @click="toggleSelectAnimal(animal)">                    
                    <span v-html="displayText(animal)"></span>
                    <span 
                      class="text-danger position-absolute top-1 end-0"
                      style="cursor: pointer; font-weight: bold; font-size: 25px; margin-right: 10px;"
                      @click.stop="toggleSelectAnimal(animal)"
                    >
                      ×
                    </span>
                  </div>
                </div>
                <p class="text-danger text-sm" v-if="selectedAnimals.length === 0" style="margin-bottom: 2px !important;">
                  {{ $t('common.No_animal_selected') }}
                </p>
                <p class="text-danger text-sm" v-if="vrulesAnimals$.selectedAnimalIds.$error">
                  {{ vrulesAnimals$.selectedAnimalIds.$errors[0].$message }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-6">
            <!-- Search Input -->
            <div class="input-group input-group-static null">
              <label class="">{{ $t('departure.Search') }}</label>
              <input v-model="state.searchQueryAnimal" type="text" class="form-control form-control-default" :placeholder="$t('departure.Search_UBN_studbooknumber_animalnumber_name')"> 
            </div>
          </div>
          <div class="col-12 mt-3">
            <!-- Available Animals -->
            <p class="fw-bold text-sm">{{ $t('departure.Available_animals') }}</p>
            <div class="row">
              <div v-for="animal in filteredAnimals" :key="animal.id" class="col-md-6 mb-1">
                <div class="card border text-sm" :class="{ 'border-success bg-light': isSelectedAnimal(animal.id), 'cursor-pointer': true }" @click="toggleSelectAnimal(animal)">                  
                  <span v-html="displayText(animal)"></span>
                </div>
              </div>
            </div>
          </div>         
        </div>        
        <div class="col-12 col-sm-12 mt-3">
          <button v-on:click="updateAnimal" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('departure.Update_animal') }}</button>
        </div>
      </div>
    </div>
    <div id="ubnto" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header pb-3">
        <h5>{{ $t('departure.Departure_UBN') }}</h5>
        <p class="mb-0 text-sm">{{ $t('departure.NB_UBN_outside_studboek') }}</p>        
      </div>
      <div class="card-body pt-0">   
        <div class="row">          
          <div class="col-6">
              <div class="input-group input-group-static null">
                  <label>{{ $t('departure.Departure_UBN') }}</label>
                  <select id="departureUbnId" v-model="state.departureUbnId" class="form-control form-control-default" :disabled="isDepartureUbnTyped">
                      <option value="">{{ $t('departure.Select_UBN') }}</option>
                      <option v-for="item in state.departureubns" :key="item.id" :value="item.id">
                          {{ item.ubn }} - {{ item.locationFullAddressDropDown }}
                      </option>
                  </select>
              </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
                <label class="">{{ $t('departure.Departure_UBN_outside_studboek') }}</label>  {{ isDepartureUbnSelected  }}             
                <input v-model="state.departureUbn" type="text" class="form-control form-control-default" :disabled="isDepartureUbnSelected" :placeholder="$t('departure.Departure_UBN_outside_studboek')">
              </div>
          </div>
        </div>
        <div class="row mt-3" v-if="userRoleName == 'Admin' || userRoleName == 'AssociationAdmin'">
          <div class="col-6">
              <div class="input-group input-group-static null">
                  <label>{{ $t('departure.Export_country') }}</label>
                  <select id="exportCountryId" v-model="state.exportCountryId" class="form-control form-control-default">
                      <option value="">{{ $t('departure.Select_export_country') }}</option>
                      <option v-for="item in state.exportcountries" :key="item.id" :value="item.id">
                          [{{ item.name }}] {{ item.description }}
                      </option>
                  </select>
              </div>
          </div>
        </div>
        <div class="row mt-3">          
          <div class="col-12">
            <span v-if="wasValidated && vrulesDepartureUBN$.formLevel?.atLeastOneProvided?.$invalid" class="text-sm text-danger">
              {{ vrulesDepartureUBN$.formLevel?.atLeastOneProvided?.$message }}
            </span>
          </div>          
        </div>
        <div class="col-12 col-sm-12 mt-3">
          <button v-on:click="updateDepartureUBN" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('departure.Update_departure_UBN') }}</button>
        </div>
      </div>
    </div>
    <div id="date" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('departure.Departure_Date') }}</h5>           
        <p class="mb-0 text-sm">{{ $t('common.Mandatory_informations') }} *</p>        
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-4">
            <div class="input-group input-group-static null">
                <label class="">{{ $t('departure.Departure_Date') }} *</label>
                <input v-model="state.departureDate" type="date" :max="todayDate" class="form-control form-control-default" :placeholder="$t('departure.Departure_Date')">
                <span v-if="vrulesDates$.departureDate.$error" class="text-sm text-danger">
                    {{ vrulesDates$.departureDate.$errors[0].$message }}
                </span>
                <span v-if="showPastDateWarning" class="text-sm text-danger d-block mt-2">
                  {{ $t('departure.7_days_message') }}
                </span>
            </div>
          </div>          
        </div> 
        <div class="row mt-4">
          <div class="col-12">
            <button v-on:click="updateDate" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('departure.Update_departure_date') }}</button>      
          </div>   
        </div>        
      </div>    
    </div>
    <div id="delete" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('common.Delete') }}</h5>
        <p class="text-sm mb-0">
          {{ $t('common.Once_you_delete_there_is_no_going_back_Please_be_certain') }}
        </p>
      </div>
      <div class="card-body d-sm-flex pt-0">
        <div class="d-flex align-items-center mb-sm-0 mb-4">
          <div>
            <material-switch id="deleteDeparture" name="Delete" @click="confirmDelete"/>
          </div>
          <div class="ms-2">
            <span class="text-dark font-weight-bold d-block text-sm">{{ $t('common.Confirm') }}</span>
            <span class="text-xs d-block">{{ $t('common.Delete_for') }} {{ state.ubn }}.</span>
          </div>
        </div>        
        <button class="btn mb-0 bg-gradient-danger btn-sm null null mb-0 ms-2" type="button" :disabled="!state.deleteDeparture" @click="deleteDeparture" name="button">{{ $t('departure.Delete_departure') }}</button>
      </div>
    </div>    
  </template>
  
  <script>
  import MaterialSwitch from "@/components/MaterialSwitch.vue";
  import axios from 'axios'
  import { useVuelidate } from '@vuelidate/core'
  import { required, helpers, } from '@vuelidate/validators'
  import { reactive, computed, nextTick, ref, watch } from 'vue'  
  import { useI18n } from 'vue-i18n'
  import Choices from 'choices.js';


  export default {
    name: "DepartureDetailItem",
    setup() {
        
      const { t } = useI18n()
      const todayDate = new Date().toISOString().split('T')[0]; 
      const state = reactive ({        
        gets: [],

        id: '',
        type: '',
        associationId: '',
        ubnId: '',
        departureUbnId: '',
        departureUbn: '',
        exportCountryId: '',
        animalIds: '',
        departureDate: null,        

        ubns:[],
        males:[],
        animals:[],

        deleteDeparture: false,        

        selectedAnimalIds: [],
        searchQueryAnimal: ''
    })
    
    const toStr = v => (v == null ? '' : String(v))

    const isDepartureUbnTyped = computed(() => toStr(state.departureUbn).trim().length > 0)
    const isDepartureUbnSelected = computed(() => !!state.departureUbnId)    
    //const isDepartureUbnTyped = computed(() => !!(state.departureUbn && state.departureUbn.trim()))

    
    watch(() => state.departureUbnId, (val) => {
      if (val) state.departureUbn = ''
    })

    watch(() => state.departureUbn, (val) => {
      const typed = toStr(val).trim()
      if (typed) {
        state.departureUbnId = ''
        // if using Choices.js, also disable its UI:
        if (typeof window !== 'undefined' && this?.choicesInstanceDepartureUBN) {
          try { this.choicesInstanceDepartureUBN.removeActiveItems() } catch { console.log('E')}
          this.choicesInstanceDepartureUBN.disable()
        }
      } else {
        if (typeof window !== 'undefined' && this?.choicesInstanceDepartureUBN) {
          this.choicesInstanceDepartureUBN.enable()
        }
      }
    })

    const rulesUBN = computed(() => ({
      ubnId: { 
          required: helpers.withMessage(t('common.Required'), required),
          isSelected: helpers.withMessage(t('common.Select_a_ubn'), value => value !== '')
      }
    }))
    
    const displayText = (f) => {
      let parts = [];

      if (f.studbookNumber) parts.push(f.studbookNumber);
      if (f.animalNumber) parts.push(f.animalNumber);
      if (f.name) parts.push(`(${f.name})`);
      if (f.arrivalDate) {
        parts.push(`<span style="color: green">${f.arrivalDate}</span>`);
      }
      if (f.breedCode) parts.push(`(${f.breedCode})`);
      return parts.join(' | ');
    }
    
    const selectedAnimalIds = ref(
      String(state.animalIds || '').split(',').filter(id => id)
    )

    const isSelectedAnimal = (id) => selectedAnimalIds.value.includes(id)

    const toggleSelectAnimal = (animal) => {
      const index = state.selectedAnimalIds.indexOf(animal.id)
      if (index > -1) {
        state.selectedAnimalIds.splice(index, 1)
      } else {
        state.selectedAnimalIds.push(animal.id)
      }
    }
    
    const selectedAnimals = computed(() =>
      state.animals.filter(f => state.selectedAnimalIds.includes(f.id))
    )

    const filteredAnimals = computed(() =>
      state.animals.filter(f =>
        !state.selectedAnimalIds.includes(f.id) &&
        displayText(f).toLowerCase().includes(state.searchQueryAnimal.toLowerCase())
      )
    )

    const rulesAnimals = computed(() => ({
      selectedAnimalIds: {
          required: helpers.withMessage(t('common.Select_at_least_one_animal'), required),
          minOne: helpers.withMessage(t('common.Select_at_least_one_animal'), value => value.length > 0)
        }
    }))

    const showPastDateWarning = computed(() => {
      if (!state.departureDate) return false;

      const selectedDate = new Date(state.departureDate);
      const today = new Date();
      const diffInDays = (today - selectedDate) / (1000 * 60 * 60 * 24);
      
      return diffInDays > 7;
    });

    const wasValidated = ref(false);

    const vrulesDepartureUBN = computed(() => ({
      departureUbnId: {
      },
      departureUbn: {
      },
      exportCountryId: {
      },
      formLevel: {
        atLeastOneProvided: helpers.withMessage(
          t('departure.Either_studboek_UBN_or_UBN_outside_studboek_required'),
          () =>
            !!state.departureUbnId || !!state.departureUbn || !!state.exportCountryId
        )
      }
    }));

    const rulesDates = computed(() => {
        return {
            departureDate: { required: helpers.withMessage(t('common.Required'), required) }            
        }
    })
    
    const vrulesUBN$ = useVuelidate(rulesUBN, state)    
    const vrulesAnimals$ = useVuelidate(rulesAnimals, state)
    const vrulesDepartureUBN$ = useVuelidate(vrulesDepartureUBN, state)
    const vrulesDates$ = useVuelidate(rulesDates, state)

    return {
        state,
        isSelectedAnimal,       
        toggleSelectAnimal,
        displayText,
        isDepartureUbnSelected,
        isDepartureUbnTyped,
        wasValidated,
        showPastDateWarning,
        selectedAnimals,
        filteredAnimals,        
        vrulesUBN$,        
        vrulesAnimals$,
        vrulesDepartureUBN$,
        vrulesDates$,
        todayDate
      }
  },  
  watch: {
      'state.departureUbn'(val) {
        const inst = this.choicesInstanceDepartureUBN;
        if (!inst) return;

        if (val && val.trim()) {
          try { inst.removeActiveItems(); } catch(_) { console.log('Error')}
          this.state.departureUbnId = '';
          inst.disable();
        } else {
          inst.enable();
        }
      },

      // optional: if dropdown gets selected (e.g., pre-filled), you can also clear text
      'state.departureUbnId'(val) {
        if (val) this.state.departureUbn = '';
      }
  },
  components: {      
    MaterialSwitch,
  },  
  async mounted() {  
      this.id = this.$route.params.id;
      this.type = this.$route.params.type;
      
      try {
            this.$store.commit('setShowLoading', true);
            await this.loadAll();            
        } catch(e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
    },    
    methods: {        
      async loadAll() {
        await this.fetchDepartureData(this.id);
        await this.fetchAllUBN();
        await this.fetchAllDepartureUBN();
        await this.fetchAllExportCountry();        
        await this.fetchAllAnimal();
      },
      async fetchDepartureData(groupGuid) {
        try {
            const response = await axios.get(`departure/group/${groupGuid}`);
            this.gets = response.data;
            
            if (this.gets.success) {
                this.state.departure = this.gets.data;

                this.state.associationId = this.state.departure.associationId;
                this.state.id = this.state.departure.id;
                this.state.groupGuid = this.state.departure.groupGuid;
                this.state.ubnId = this.state.departure.ubnid;

                this.state.departureUbnId = this.state.departure.departureUbnId || '';

                this.state.departureUbn = this.state.departure.departureUbn != null
                  ? String(this.state.departure.departureUbn)
                  : '';

                this.state.exportCountryId = this.state.departure.exportCountryId || '';
                
                this.state.animalIds = this.state.departure.animalIds;
                this.state.departureDate = this.state.departure.departureDate;
                
                this.state.selectedAnimalIds = this.state.departure.animalIds
                                              ? this.state.departure.animalIds.split(',').map(id => id.trim())
                                              : [];

            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch(e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
      },
      async fetchAllUBN()
      {
          try { 
              const response = await axios.get("Location/getallbyassociation", {
                  params: {
                      associationId: this.state.associationId
                  }
              });
              const result = response.data;

              if (result.success && Array.isArray(result.data.locationList)) {
                  this.state.ubns = result.data.locationList;

                  await nextTick();

                  this.initializeChoicesDropdown({
                      id: "ubnId",
                      dataList: this.state.ubns,
                      selectedValue: this.state.ubnId,
                      instanceKey: "choicesInstanceUBN"
                  });
              } else {    
                  this.$showSuccess('errors.Error_fetching_ubns');
              }                
          } catch (e) {
              const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
              this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
      },
      async fetchAllDepartureUBN()
      {
          try { 
              const response = await axios.get("Location/getallbyassociation", {
                  params: {
                      associationId: this.state.associationId
                  }
              });
              const result = response.data;

              if (result.success && Array.isArray(result.data.locationList)) {

                  this.state.departureubns = result.data.locationList;
                  await nextTick();

                  this.initializeChoicesDropdown({
                      id: "departureUbnId",
                      dataList: this.state.departureubns,
                      selectedValue: this.state.departureUbnId,
                      instanceKey: "choicesInstanceDepartureUBN"
                  });
              } else {    
                  this.$showSuccess('errors.Error_fetching_ubns');
              }   
          } catch (e) {
              const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
              this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
      },
      async fetchAllAnimal() 
      {
          try { 
              const response = await axios.get("Animal/getalldeparture", {
                  params: {
                      associationId: this.state.associationId,                        
                      animalTypeId: '1469f04a-a84e-48a5-b79b-bd69f3a5bd51',
                      ubnId: this.state.ubnId
                  }
              });
              const result = response.data;

              if (result.success && Array.isArray(result.data)) {
                  this.state.animals = result.data.sort((a, b) => (b.animalNumber ?? '').localeCompare(a.animalNumber ?? ''));
              } else {    
                  this.$showSuccess('errors.Error_fetching_animals');
              }                
          } catch (e) {
              const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
              this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
      },
      async fetchAllExportCountry()
      {
          try {
              const response = await axios.get("reference/getreference", {
                  params: {
                      referenceTypeId: '8e7cedbf-891f-481e-bb84-07efd0aa8188'
                  }
              });
              const result = response.data;

              if (result.success && Array.isArray(result.data)) {
                  
                  this.state.exportcountries = result.data;
                  await nextTick();

                  this.initializeChoicesDropdown({
                      id: "exportCountryId",
                      dataList: this.state.exportcountries,
                      selectedValue: this.state.exportCountryId,
                      instanceKey: "choicesExportCountry"
                  });
              } else {    
                  this.$showSuccess('errors.Error_fetching_export_country');
              }                
          } catch (e) {
              const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
              this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
      },
      initializeChoicesDropdown({ id, dataList, selectedValue, instanceKey }) {
        const element = document.getElementById(id);
        if (!element || element.tagName !== "SELECT") {
          console.error(`Choices: Invalid or missing select element with ID "${id}".`);
          return;
        }

        if (this[instanceKey]) {
          this[instanceKey].destroy();
        }

        this[instanceKey] = new Choices(element, {
          searchEnabled: true,
          itemSelectText: '',
          shouldSort: false,
          placeholder: true,
        });

        // set value (single-select expects string, not array)
        if (selectedValue) {
          const exists = dataList.some(x => x.id === selectedValue);
          this[instanceKey].setChoiceByValue(exists ? String(selectedValue) : '');
        } else {
          this[instanceKey].removeActiveItems();
        }

        // keep Vue v-model updated
        element.addEventListener('change', (e) => {
          const val = e.target.value || '';
          if (id === 'ubnId') this.state.ubnId = val;
          if (id === 'departureUbnId') this.state.departureUbnId = val;
          if (id === 'exportCountryId') this.state.exportCountryId = val;
        });

        // reflect disabled state initially for the wrapped control
        if (id === 'departureUbnId') {
          if (this.state.departureUbn && this.state.departureUbn.trim()) {
            this[instanceKey].disable();
          } else {
            this[instanceKey].enable();
          }
        }
      },

      initializeChoicesDropdown1({ id, dataList, selectedValue, instanceKey }) {
          const element = document.getElementById(id);
          if (!element || element.tagName !== "SELECT") {
              console.error(`Choices: Invalid or missing select element with ID "${id}".`);
              return;
          }

          // Destroy previous instance if it exists
          if (this[instanceKey]) {
              this[instanceKey].destroy();
          }

          // Initialize new Choices instance
          this[instanceKey] = new Choices(element, {
              searchEnabled: true,
              itemSelectText: '',
              shouldSort: false,
              placeholder: true,
          });

          // Set selected value if it exists in list
          if (selectedValue) {
              const optionExists = dataList.some(item => item.id === selectedValue);
              this[instanceKey].setChoiceByValue(optionExists ? [selectedValue] : '');
          }
      },                    
      async updateUBN() {   
        try {
            this.$store.commit('setShowLoading', true);

            this.vrulesUBN$.$validate();
            
            if(!this.vrulesUBN$.$error) {
                const response = await axios.put('departure/updateubn', {
                  "groupGuid": this.state.groupGuid,
                  "ubnId": this.state.ubnId                  
                });
                this.gets = response.data;

                if (this.gets.success) {
                  
                  this.$showSuccess('errors.Success_departure_ubn_updated_successfully');
                  
                  this.$router.push({ path: `/departure/edit/${this.state.groupGuid}` }).then(() => {
                    this.fetchDepartureData(this.state.groupGuid);
                  });
                } else {
                  this.$showError('errors.Contact_system_admin');
                }
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },      
      async updateAnimal() {   
        try {
            this.$store.commit('setShowLoading', true);
            this.vrulesAnimals$.$validate();
            
            if(!this.vrulesAnimals$.$error) {

              const response = await axios.put('departure/updateanimal', {
                "groupGuid": this.state.groupGuid,                         
                "animalIds": this.state.selectedAnimalIds.join(',')                
              });
              this.gets = response.data;

              if (this.gets.success) {
                this.$showSuccess('errors.Success_departure_animal_updated_successfully');
                
                this.$router.push({ path: `/departure/edit/${this.state.groupGuid}` }).then(() => {
                  this.fetchDepartureData(this.state.groupGuid); // Trigger data refresh or any required action
                });
              } else {
                this.$showError('errors.Contact_system_admin');
              }
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },
      async updateDepartureUBN() {   
        try {
          this.$store.commit('setShowLoading', true);

          this.wasValidated = true; // mark validated
          const valid = await this.vrulesDepartureUBN$.$validate();

          if (!valid) return; // stop if errors

          const typed = this.state.departureUbn?.trim();
          const departureUbnNum =
            typed && typed.length > 0 ? Number(typed) : null;

          if (typed && Number.isNaN(departureUbnNum)) {
            this.$showError(this.$t('errors.Please_enter_a_valid_numeric_UBN'));
            return;
          }

          const response = await axios.put('departure/updateubnto', {
            groupGuid: this.state.groupGuid,
            departureUbnId: this.state.departureUbnId,
            departureUbn: departureUbnNum,
            exportCountryId: this.state.exportCountryId
          });

          this.gets = response.data;

          if (this.gets.success) {
            this.$showSuccess('errors.Success_departure_to_ubn_updated_successfully');
            this.$router.push({ path: `/departure/edit/${this.state.groupGuid}` })
              .then(() => this.fetchDepartureData(this.state.groupGuid));
          } else {
            this.$showError('errors.Contact_system_admin');
          }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },  
      async updateDate() {   
        try {
            this.$store.commit('setShowLoading', true);            
            
            const valid = await this.vrulesDates$.$validate();
            if (!valid) return;

            const response = await axios.put('departure/updatedate', {
              groupGuid: this.state.groupGuid,
              departureDate: this.state.departureDate
            });
            this.gets = response.data;

            if (this.gets.success) {
              this.$showSuccess('errors.Success_departure_date_updated_successfully');
              
              this.$router.push({ path: `/departure/edit/${this.state.groupGuid}` }).then(() => {
                this.fetchDepartureData(this.state.groupGuid); // Trigger data refresh or any required action
              });
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },
      confirmDelete() {
        this.state.deleteDeparture = !this.state.deleteDeparture;
      },      
      deleteDeparture() {
        if (this.state.deleteDeparture) {
          this.deleteDeparture1(this.state.groupGuid)
        }
      },                  
      async deleteDeparture1(groupGuid) {   
        try {
            
            this.$store.commit('setShowLoading', true);

            const response = await axios.delete("departure/group/" + groupGuid);
            this.gets = response.data;

            if (this.gets.success) {

              this.$showSuccess('errors.Success_departure_deleted_successfully');
              
              this.$router.push('/departure');                
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {          
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      }
    }
  };
  </script>
  <style scoped>
  .card {
    transition: background-color 0.2s ease-in-out;
    cursor: pointer;
    position: relative;
    padding: 10px !important;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .bg-light {
    background-color: #f9f9f9 !important;
  }
  .border-success {
    border-color: #28a745 !important;
  }
</style>